import React from "react";

function Icon({ attr }) {
    return (
        <i className={`${attr} is-size-3 is-size-1-tablet fa-2xl level-item pt-2 my-3 px-1 myIcon`}></i>
    )
}

export default Icon 